import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'

// Import multiRoomCurrentStep action
import manageMultiRoom from '../../actions/multiRoomActions'

import BkFlowLoader from '../../components/elements/BkFlowLoader'
import BkFlowRoomFilters from '../../components/filters/BkFlowRoomFilters'
import BkFlowPropertyAmenities from '../../components/property/BkFlowPropertyAmenities'
import BkFlowRoomCards from '../../components/room/BkFlowRoomCards'
import BkFlowError from '../../components/elements/BkFlowError'
import BkFlowPolicies from '../../components/policies/BkFlowPolicies'
import DisloyaltyBanner from '../../components/loyalty/DisloyaltyBanner'

// GA events handler
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'
import moment from 'moment/moment'

import backArrow from '.././../assets/icons/arrow-left.svg'

import '../../styles/css/base/popover.css'
import '../../styles/css/components/stepper/bk-flow-steps.css'

import _ from 'lodash'
import yn from 'yn'

class BkFlowRoomContain extends Component {

	constructor(props) {
		super(props)
		this.state = {
			currentTabStep: 0
		}
	}

	componentDidMount() {
		const {
			currentQuery,
			configData,
			availabilityData
		} = this.props

		if (
			currentQuery &&
			currentQuery.query
		) {
			window.history.pushState({}, '', '/book?' + this.props.currentQuery.query)
		}

		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-pageView', window.location.href)

		if (
			process.env.REACT_APP_COMPONENT_ROOM_CONTENT_WIDTH === 'full'&&
			document.getElementById('bk-flow-room-content')
		) {
			document.getElementById('bk-flow-room-content').classList.add('u-container--full')
		} else if (
			configData &&
			availabilityData &&
			yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR) &&
			document.getElementById('bk-flow-room-content')
		) {
			document.getElementById('bk-flow-room-content').classList.remove('u-container')
		}
	}

	renderCard() {
		const {
			configData,
			urlData,
			availabilityData,
			availabilityLoading,
			availabilityError
		} = this.props

		let activeHotelCode = null,
				activePropertyPhoneNumber = null,
				activePropertyLink = null

		// Get hotel code from avail response
		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			// Set phone # by config or synxis fallback
			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activePropertyPhoneNumber = matchedProperty.contactNumbers.reservations
			}

			if ( !_.isEmpty(matchedProperty) && matchedProperty.marketingLink ) {
				activePropertyLink = matchedProperty.marketingLink
			} else if (configData.core.options.links.brandMarketingLink){
				activePropertyLink = configData.core.options.links.brandMarketingLink
			}
		}

		const hotelLabels = configData.hotel.labels[0],
					arrivalDate = moment(urlData.startDate),
					departureDate = moment(urlData.endDate),
					totalNights = departureDate.diff(arrivalDate, 'days')

		let extendedStayThreshold = 29

		if (process.env.REACT_APP_COMPONENT_EXTENDED_STAY_THRESHOLD) {
			extendedStayThreshold = process.env.REACT_APP_COMPONENT_EXTENDED_STAY_THRESHOLD
		}

		// display extended stay message or room cards
		if (totalNights >= Number(extendedStayThreshold)) {
			return (
				<Fragment>
					<h5 className="u-txt-center">{ hotelLabels.extendedStayTitle ? hotelLabels.extendedStayTitle : 'Thanks for choosing us as your home for an extended stay' }</h5>
					<p>
						{ hotelLabels.extendedStayMessage ? hotelLabels.extendedStayMessage : 'To book a stay longer than 29 days, please reach out to us at' }:&nbsp;
						{ activePropertyPhoneNumber ? <a href={ 'tel:' + activePropertyPhoneNumber }>{ activePropertyPhoneNumber }</a> : null }
					</p>
				</Fragment>
			)
		} else if (availabilityData) {
			return (
				<Fragment>
					{ !availabilityLoading &&
						!availabilityError &&
						yn(process.env.REACT_APP_COMPONENT_ROOM_FILTERS) &&
						<BkFlowRoomFilters
							roomGroup={0}
						/>
					}


					{ !availabilityLoading &&
						!availabilityError &&
						yn(process.env.REACT_APP_COMPONENT_PROPERTY_AMENITIES_CAROUSEL) &&
							<BkFlowPropertyAmenities />
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_HEADING) &&
						<h2 className="u-remove-margin">

							{ yn(process.env.REACT_APP_COMPONENT_BREADCRUMB_BACK_BUTTONS) &&
								<button
									className="btn btn-text-only"
									onClick={ activePropertyLink ? () => window.location = activePropertyLink : () => window.location = '/' }
								>
									<img src={ backArrow } alt="Return to previous page" />
									{ hotelLabels && hotelLabels.home ? hotelLabels.home : 'Home' }
								</button>
							}

							{ hotelLabels.selectYourRoom ? hotelLabels.selectYourRoom : 'Select Your Room' }
						</h2>
					}
					{!availabilityLoading && !_.isEmpty(_.get(availabilityData, '[0][0].roomTypes')) && <DisloyaltyBanner hotelCode={activeHotelCode} />}
					<BkFlowRoomCards key="room-group-0" roomGroup={ 0 } />
				</Fragment>
			)
		}
	}

	// Init Steps
	 getRoomSteps() {
		const { multiRoomData, availabilityData } = this.props
		const roomTabs = []

		if (availabilityData) {
			if (multiRoomData.isMultiRoom && multiRoomData.multiRoomTotal > 1) {
				for (let i = 0; i < multiRoomData.multiRoomTotal; i++) {
					roomTabs.push(i)
				}
			}
			return roomTabs
		}
	}

	// Declare components per step
	getRoomStepContent = (step) => {
		const {
			configData,
			urlData,
			multiRoomData,
			availabilityLoading,
			availabilityError
		} = this.props

		let activeHotelCode = null,
				activePropertyPhoneNumber = null

		// Get hotel code from avail response
		if (!_.isEmpty(urlData) && urlData.hotelCode) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})
			// Set phone # by config or synxis fallback
			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activePropertyPhoneNumber = matchedProperty.contactNumbers.reservations
			}
		}

		const hotelLabels = configData.hotel.labels[0],
					arrivalDate = moment(urlData.startDate),
					departureDate = moment(urlData.endDate),
					totalNights = departureDate.diff(arrivalDate, 'days')

		let extendedStayThreshold = 29

		if (process.env.REACT_APP_COMPONENT_EXTENDED_STAY_THRESHOLD) {
			extendedStayThreshold = process.env.REACT_APP_COMPONENT_EXTENDED_STAY_THRESHOLD
		}

		// display extended stay message or room cards
		if (totalNights >= Number(extendedStayThreshold)) {
			return (
				<Fragment>
					<h5 className="u-txt-center">{ hotelLabels.extendedStayTitle ? hotelLabels.extendedStayTitle : 'Thanks for choosing us as your home for an extended stay' }</h5>
					<p>
						{ hotelLabels.extendedStayMessage ? hotelLabels.extendedStayMessage : 'To book a stay longer than 29 days, please reach out to us at' }:&nbsp;
						{ activePropertyPhoneNumber ? <a href={ 'tel:' + activePropertyPhoneNumber }>{ activePropertyPhoneNumber }</a> : null }
					</p>
				</Fragment>
			)
		} else {
			return (
				<div className="bk-flow-room__multi-group">
					{ !availabilityLoading &&
						!availabilityError &&
						yn(process.env.REACT_APP_COMPONENT_ROOM_FILTERS) &&
						<BkFlowRoomFilters
							roomGroup={step}
						/>
					}

					{ !availabilityLoading &&
						!availabilityError &&
						yn(process.env.REACT_APP_COMPONENT_PROPERTY_AMENITIES_CAROUSEL) &&
						<BkFlowPropertyAmenities />
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_HEADING) &&
						<h2 className="u-remove-margin u-txt-center">
							{ hotelLabels.selectRoom } { multiRoomData.currentMultiRoomStep + 1 }
						</h2>
					}
					<BkFlowRoomCards key={ 'activeRoom' + step } roomGroup={ step }/>
				</div>
			)
		}
	}

	render() {
		const {
			configData,
			hotelDescriptiveInfoLoading,
			availabilityLoading,
			availabilityData,
			availabilityError,
			multiRoomData,
			activeRoom,
			toggleRoomTab
		} = this.props

		const steps = this.getRoomSteps()
		const hotelLabels = configData.hotel.labels[0]

		// Enable stepper button if room active
		const isStepperDisabled = (stepKey) => {
			let multiTotal = []

			for (let roomKeys in activeRoom) {
				multiTotal.push(parseInt(roomKeys, 0))
			}

			return multiTotal.includes(stepKey)
		}

		// Style overrides for tab stepper
		const theme = createMuiTheme({
			overrides: {
				MuiStepper: {
					root: {
						justifyContent: 'center',
						background: 'rgba(0,0,0,0)',
						padding: '0',
					},
				},
				MuiStep: {
					root: {
						background: 'rgba(0,0,0,0)',
					},
					horizontal: {
						paddingLeft: '0',
						paddingRight: '1px',
					},
				},
				MuiStepLabel: {
					root: {
						backgroundColor: 'rgba(0,0,0,0)',
						width: '100%',

						button: {
							color: '#000',
						}
					},
					active: {
						backgroundColor: 'rgba(0,0,0,0)',
					},
					labelContainer: {
						backgroundColor: 'rgba(0,0,0,0)',
						color: '#333333',
					},
					label: {
						padding: '10px',
					},
				},
			},
		})

		// Display avail error
		if (availabilityError) {
			return (
				<BkFlowError
					configData={ configData}
					availabilityData={ availabilityData }
					requestError={ availabilityError.message }
				/>
			)
		}

		if (
			availabilityLoading ||
			hotelDescriptiveInfoLoading
		) {
			return <BkFlowLoader />
		}

		return (
			<div className="bk-flow-room">
				<div
					id="bk-flow-room-content"
	        className="u-container"
				>
					{ multiRoomData.isMultiRoom ?
						<div className="bk-multi-room-steps">
							<MuiThemeProvider theme={ theme }>
								<Stepper
									activeStep={ multiRoomData.currentMultiRoomStep }
									connector={ null }
								>
									{ steps.map((label) => {
										const props = {}
										const labelProps = {}

										return (
											<Step className="u-flex-item" key={ label } { ...props }>
												<StepLabel className="bk-flow-steps__labels" { ...labelProps }>
													<button
														disabled={!isStepperDisabled(label)}
														className="bk-flow-steps__tab-btn btn"
														onClick={ () => toggleRoomTab(multiRoomData.isMultiRoom, multiRoomData.multiRoomTotal, label) }>{ hotelLabels.room } {label + 1}
														</button>
												</StepLabel>
											</Step>
										)
									})}
								</Stepper>
							</MuiThemeProvider>
							{ this.getRoomStepContent(multiRoomData.currentMultiRoomStep) }
						</div>
					:
						this.renderCard()
					}

					{ yn(process.env.REACT_APP_COMPONENT_ROOM_PROPERTY_POLICIES) &&
						<BkFlowPolicies />
					}
				</div>
			</div>
		)
	}
}

//connects root reducer to props
function mapStateToProps(state) {
	return {
		multiRoomData: state.multiRoomData,
		configData: state.configData.configuration,
		currentQuery: state.availabilityData.currentQuery,
		urlData: state.availabilityData.urlData,
		hotelDescriptiveInfoLoading: state.hotelDescriptiveInfo.loading,
		availabilityData: state.availabilityData.availability,
		availabilityLoading: state.availabilityData.loading,
		availabilityError: state.availabilityData.error,
		activeRoom: state.activeRoomData,
		activeStep: state.activeStepData.activeStep
	}
}

const mapDispatchToProps = dispatch => ({
	toggleRoomTab(isMultiRoom, multiRoomTotal, newTabStep) {
		return (
			dispatch(manageMultiRoom(isMultiRoom, multiRoomTotal, newTabStep))
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomContain)


// WEBPACK FOOTER //
// ./src/containers/rooms/BkFlowRoomContain.js